import {
  BottomSheet,
  BottomSheetIllustrationContent,
  Text,
  type UseModalState,
} from "@clipboard-health/ui-components";
import { Button } from "@src/appV2/redesign/components/Button";
import { DialogFooter } from "@src/appV2/redesign/components/DialogFooter";
import { useHistory } from "react-router-dom";

import { MY_SHIFTS_FULL_PATH } from "../../WorkerShifts/path";

interface VisitDroppedBottomSheetProps {
  modalState: UseModalState;
}

export function VisitDroppedBottomSheet(props: VisitDroppedBottomSheetProps) {
  const { modalState } = props;
  const history = useHistory();

  return (
    <BottomSheet
      modalState={modalState}
      footer={
        <DialogFooter orientation="vertical">
          <Button
            fullWidth
            variant="contained"
            onClick={() => {
              history.replace(MY_SHIFTS_FULL_PATH);
            }}
          >
            Continue
          </Button>
        </DialogFooter>
      }
    >
      <BottomSheetIllustrationContent
        illustrationType="cancellation"
        title="Visit dropped"
        description={
          <Text variant="body2">
            You&apos;ve lost <b>-10</b> points from your Attendance Score.
          </Text>
        }
      />
    </BottomSheet>
  );
}
